<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>计划管理</el-breadcrumb-item>
			<el-breadcrumb-item>产品管理</el-breadcrumb-item>
			<el-breadcrumb-item>产品导入</el-breadcrumb-item>
		</el-breadcrumb>

		<div class="form-bar">
			<el-row>
				<el-col :span="12">
					<el-form :inline="true">
						<el-form-item label="下载模板">
							<a href="file/产品导入模板.xlsx" style="margin-right:20px;">点击下载模板</a>
						</el-form-item>
						<el-form-item>
							<input type="file" ref="inputFile" @change="handleSelectFile($event)" />
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :span="12" style="text-align:right;">
					<el-button type="primary" :disabled="excelData.length == 0" @click="check">数据校验</el-button>
					<el-button type="primary" :disabled="!available" @click="submit" :loading="saving">导入</el-button>
					<el-button type="info" @click="$router.back()">返回</el-button>
				</el-col>
			</el-row>
		</div>

		<el-table border :data="excelData">
			<el-table-column type="index" width="60" label="行号"></el-table-column>
			<el-table-column prop="name" label="名称">
				<template scope="scope">
					<div v-text="scope.row.name"></div>
					<small class="error" v-text="scope.row.validateInfo.name"></small>
				</template>
			</el-table-column>
			<el-table-column prop="code" label="编号" width="100">
				<template scope="scope">
					<div v-text="scope.row.code"></div>
					<small class="error" v-text="scope.row.validateInfo.code"></small>
				</template>
			</el-table-column>
			<el-table-column prop="created_time" label="创建时间" width="130">
				<template scope="scope">
					<div v-text="scope.row.created_time"></div>
					<small class="error" v-text="scope.row.validateInfo.created_time"></small>
				</template>
			</el-table-column>
			<el-table-column prop="grade" label="等级" width="100">
				<template slot-scope="scope">
					<div v-text="scope.row.grade"></div>
					<small class="error" v-text="scope.row.validateInfo.grade"></small>
				</template>
			</el-table-column>
			<el-table-column prop="remark" label="备注" width="180">
				<template slot-scope="scope">
					<div v-text="scope.row.remark"></div>
					<small class="error" v-text="scope.row.validateInfo.remark"></small>
				</template>
			</el-table-column>
			<el-table-column prop="processGroupName" label="工序组" width="180">
				<template slot-scope="scope">
					<div v-text="scope.row.processGroupName"></div>
					<small class="error" v-text="scope.row.validateInfo.processGroupName"></small>
				</template>
			</el-table-column>
			<el-table-column prop="techGroupName" label="工艺参数组" width="180">
				<template slot-scope="scope">
					<div v-text="scope.row.techGroupName"></div>
					<small class="error" v-text="scope.row.validateInfo.techGroupName"></small>
				</template>
			</el-table-column>
			<el-table-column label="校验结果" width="180">
				<template slot-scope="scope">
					<div :class="{ result: true, error: scope.row.hasError, success: scope.row.isValid }" v-text="scope.row.message"></div>
				</template>
			</el-table-column>
			<el-table-column label="操作" width="120">
				<template slot-scope="scope">
					<el-button type="text" @click="remove(scope.$index)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
	import { ProductImport } from '@/components/Product'
	export default {
		data() {
			return {
				pi: {},
				excelData: [],
				available: false,
				saving: false,
			}
		},
		watch: {},
		methods: {
			handleSelectFile() {
				console.log('handleSelectFile1', event)
				if (!event.target.files) {
					return
				}

				var self = this
				var f = event.target.files[0]

				this.pi = new ProductImport(f, data => {
					console.log('导入完成', data)

					this.excelData = data
				})

				this.$refs.inputFile.value = ''
			},
			/**
			 * 进行数据校验。
			 */
			async check() {
				for (let i = 0; i < this.excelData.length; i++) {
					const t = this.excelData[i]
					this.excelData[i] = await this.pi.validate(t)
				}

				if (this.excelData.length > 0 && this.excelData.filter(t => t.hasError) == 0) {
					this.available = true
				}
			},
			/**
			 * 导入
			 */
			submit() {
				if (this.saving) {
					return
				} else {
					this.saving = true
				}

				this.pi
					.save()
					.then(res => {
						if (res.data.inserted == this.excelData.length) {
							this.$alert(`全部数据导入成功，数据量：${this.excelData.length}<br/>点击返回产品列表`, '提示', {
								dangerouslyUseHTMLString: true,
								confirmButtonText: '确定',
								callback: action => {
									this.$router.back()
								},
							})
						} else {
							console.log('导入成功：', res.data.inserted)
						}
					})
					.finally(() => {
						this.saving = false
					})
			},
			/**
			 * 删除记录
			 */
			remove(index) {
				this.pi.deleteRow(index)

				if (this.excelData.length > 0 && this.excelData.filter(t => t.hasError) == 0) {
					this.available = true
				}
			},
		},
	}
</script>

<style lang="less" scoped>
	.empty {
		height: 300px;
	}

	.result {
		color: #000;
	}

	.error {
		color: #ce0000;
	}

	.result.success {
		color: #00b75a;
	}
</style>
